import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { useTableInstance } from '../../contexts/table_context.js';
export function BatchActionsResultsSummary({ showSelectedAll = false }) {
    const { rows, isAllRowsSelected, toggleAllRowsSelected, state: { selectedRowIds } } = useTableInstance();
    const intl = useIntl();
    const totalRecords = rows.length;
    const selectedCount = Object.keys(selectedRowIds).length;
    const messages = defineMessages({
        item1: {
            defaultMessage: 'All {count, plural, one {# row is} other {# rows are}} selected',
            id: '4wlRU+',
            description: 'Label for all rows selected'
        },
        item2: {
            defaultMessage: '{count, plural, one {# row on this page is} other {# rows on this page are}} selected',
            id: 'k9rWwT',
            description: 'Label for one or more or all rows selected per page'
        },
        item3: {
            defaultMessage: '{count, plural, one {# row is} other {# rows are}} selected',
            id: 'ZmEXmi',
            description: 'Label for one or more rows selected'
        }
    });
    return (React.createElement(React.Fragment, null,
        showSelectedAll ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "twds-font-lato twds-text-xs dark:twds-text-blue-steel-400" }, isAllRowsSelected ? (React.createElement(FormattedMessage, { values: {
                    count: selectedCount
                }, ...messages.item1 })) : (React.createElement(FormattedMessage, { values: {
                    count: selectedCount
                }, ...messages.item2 }))),
            React.createElement("button", { type: "button", "data-testid": "batch-actions-select-all", className: "twds-border-none twds-bg-transparent twds-font-lato twds-text-xs twds-cursor-pointer twds-text-blue-600", onClick: () => toggleAllRowsSelected(true) }, intl.formatMessage({
                defaultMessage: 'Select all {number} rows',
                id: 'N6xsWI',
                description: 'Label for checkbox to select all rows'
            }, {
                number: totalRecords
            })))) : (React.createElement("div", { className: "twds-font-lato twds-text-xs dark:twds-text-blue-steel-400" },
            React.createElement(FormattedMessage, { values: {
                    count: selectedCount
                }, ...messages.item3 }))),
        React.createElement("button", { type: "button", "data-testid": "batch-actions-deselect-all", className: "twds-border-none twds-bg-transparent twds-font-lato twds-text-xs twds-cursor-pointer twds-text-blue-600", onClick: () => toggleAllRowsSelected(false) }, intl.formatMessage({
            defaultMessage: 'Deselect all',
            id: '8r3ykH',
            description: 'Label for checkbox to deselect all rows'
        }))));
}
//# sourceMappingURL=BatchActionsResultsSummary.js.map